import { registerModal } from 'features/Modal/ModalRegistry'
import NumbersNewServiceModal from './NumbersNewServiceModal.container'
import { showModal } from 'features/Modal/Modal.actions'

export const modalType = 'NEW_SERVICE'
registerModal(modalType, NumbersNewServiceModal)
export default modalProps =>
  showModal({
    modalType,
    modalProps,
    modalOptions: {},
  })



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersNewServiceModal/NumbersNewServiceModal.action.js